// extracted by mini-css-extract-plugin
export var banner = "_ep-0";
export var closeButton = "_ep-2";
export var greenCheckmark = "_ep-3";
export var hereLink = "_ep-4";
export var titleIcon = "_ep-1";